<template>
  <div class="main">
    <report-top
      ><template slot="search">
        <ly-search
          v-model="searchItem.keyword"
          @search="search"
        ></ly-search> </template
    ></report-top>
    <div id="formTable">
      <div id="text">
        当前位置：<a @click="home">一级单位</a
        ><a
          style="margin-right: 4px"
          v-for="(item, index) in mianbao"
          :key="index"
          @click="back(item, index)"
          ><Icon type="ios-arrow-forward" />{{ item.name }}</a
        >
      </div>
      <div id="ddas">
        <Button @click="getDeList" size="small" icon="ios-copy">标签</Button>
        <Button @click="openaddparent" type="primary" size="small"
          >新增一级单位</Button
        >
      </div>
    </div>
    <Table
      :data="tableData"
      :columns="columns"
      stripe
      ref="table"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-selection-change="selectCars = $event"
    >
      <template slot-scope="{ row, index }" slot="title">
        <span @click="chakanxiaji(row)"
          ><Icon type="ios-arrow-forward" v-show="row.childList.length > 0" />
          <a v-show="row.childList.length > 0">{{ row.name }}</a>
          <span v-show="row.childList.length == 0">{{ row.name }}</span>
        </span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openAdd(row)">新增</Button>
        <Button size="small" @click="openUpdate(row)">编辑</Button>
        <Button size="small" @click="del(row)">删除</Button>
      </template>
    </Table>
    <Modal v-model="groupModal" :title="modalTitle" footer-hide width="700">
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="单位名称" prop="name">
              <Input v-model="item.name"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="排序" prop="sort">
              <Input type="number" v-model="item.sort"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="负责人" prop="charge">
              <Input v-model="item.charge"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="联系方式" prop="contact">
              <Input v-model="item.contact"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="备注" prop="remark">
              <Input type="textarea" v-model="item.remark"></Input>
            </FormItem>
          </Col>
        </Row>

        <Row type="flex" justify="end">
          <Col span="12">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="addUpdate('item')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <carLabel ref="carLabel" @labelSaveFinish="getList"></carLabel>
  </div>
</template>
<script>
import axios from "axios";
import carLabel from "./groupLabel.vue";
export default {
  components: { carLabel },
  data() {
    return {
      isAdd: true,
      groupModal: false,
      modalTitle: "",
      columns: [
        {
          type: "selection",
          width: 70,
          align: "center",
          tooltip: true,
        },
        {
          title: "单位名称",
          slot: "title",
        },
        {
          title: "排序",
          key: "sort",
        },
        {
          title: "上级单位",
          key: "pname",
        },
        {
          title: "负责人",
          key: "charge",
        },
        {
          title: "联系方式",
          key: "contact",
        },
        {
          title: "创建者账号",
          key: "createAccount",
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "备注",
          key: "remark",
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
        },
      ],
      tableData: [],
      mianbao: [],
      item: {
        name: "",
        sort: 1,
        charge: "",
        contact: "",
        pid: 0,
        remark: "",
        //type: "",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        sort: { required: true, message: "必填" },
      },
      searchItem: {
        keyword: "",
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.bm + "/group/tree",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        console.log(res);
        var that = this;
        function menu(t) {
          for (let i = 0; i < t.length; i++) {
            that.autoUpdate(t[i]);
            if (t[i].childList.length > 0) {
              menu(t[i].childList);
            }
          }
          return t;
        }
        this.treeData = menu(data);
        if (this.mianbao.length == 0) {
          this.tableData = this.treeData;
        }
      });
    },
    addUpdate(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          console.log(this.isAdd);
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.bm + "/group/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res.data.code != 200) {
                this.$Message.error(res.data.message);
              } else {
                this.cliclCancelBtn();
                this.getList();
              }
            });
          } else {
            console.log(this.item);
            axios({
              method: "post",
              url: axios.bm + "/group/update",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res.data.code != 200) {
                this.$Message.error(res.data.message);
              } else {
                this.cliclCancelBtn();
                this.getList();
              }
            });
          }
        }
      });
    },
    del(row) {
      let params = { idList: [row.id] };
      this.$Modal.confirm({
        title: "确定要删除【" + row.name + "】单位/功能？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.bm + "/group/del",
            data: params,
          }).then((res) => {
            if (res) {
              this.openForm = false;
              this.getList();
            }
          });
        },
      });
    },
    cliclCancelBtn() {
      this.groupModal = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    openaddparent() {
      this.modalTitle = "新增一级单位";
      this.item.pid = 0;
      this.groupModal = true;
    },
    openAdd(row) {
      this.isAdd = true;
      this.groupModal = true;
      this.item.pid = row.id;
      this.modalTitle = "新增【" + row.name + "】下级单位";
    },
    openUpdate(row) {
      this.modalTitle = "编辑【" + row.name + "】单位";
      this.isAdd = false;
      this.groupModal = true;
      this.item = row;
    },
    //新的
    chakanxiaji(item) {
      if (item.childList.length == 0) {
        return;
      }
      this.tableData = item.childList;
      this.mianbao.push(item);
    },
    back(item, index) {
      this.tableData = item.childList;
      this.mianbao.splice(index + 1, this.mianbao.length - (index + 1));
      //长度3 当前index0 删除位置1 删除个数2
      //长度3 当前index1 删除位置2 删除个数1
      //长度4 当前index0 删除位置1 删除个数3
      //长度4 当前index1 删除位置2 删除个数2
      //长度4 当前index2 删除位置3 删除个数1
    },
    home() {
      this.getList();
      this.mianbao = [];
    },
    autoUpdate(gold) {
      if (this.mianbao.length > 0) {
        var aa = this.mianbao[this.mianbao.length - 1].id;
        if (gold.id == aa) {
          this.tableData = gold.childList;
        }
      }
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    search() {
      this.home();
    },
    //多选模式下。将选中的放到deList里边,目前批量转移接用
    getDeList(y) {
      var x = this.selectCars;
      if (x.length == 0) {
        this.$Message.error("至少选择一台车");
        return;
      }
      if (y == 1) {
        this.openTransferForm = true;
      } else {
        this.$refs.carLabel.reachData(x);
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/information/group.vue